import { useMemo } from "react";
import { Color } from "three";
import { games } from "../../content/siteContent";

type GameRouteSceneProps = {
  slug: string | null;
};

export function GameRouteScene({ slug }: GameRouteSceneProps) {
  const game = games.find((entry) => entry.slug === slug) ?? games[0];
  const primary = useMemo(() => new Color(game.palette.primary), [game.palette.primary]);
  const secondary = useMemo(() => new Color(game.palette.secondary), [game.palette.secondary]);

  return (
    <group position={[0, 0.1, -0.8]}>
      <mesh position={[0, 0.2, 0]} scale={[1.4, 1.4, 1.4]}>
        <icosahedronGeometry args={[1.15, 1]} />
        <meshStandardMaterial color={primary} emissive={primary} emissiveIntensity={0.18} metalness={0.4} roughness={0.22} />
      </mesh>

      <mesh position={[2.25, -0.6, -0.4]} scale={[0.52, 0.52, 0.52]}>
        <sphereGeometry args={[1, 32, 32]} />
        <meshStandardMaterial color="#f4efe8" emissive={secondary} emissiveIntensity={0.12} />
      </mesh>

      <mesh position={[-2.2, 1.05, -0.8]} scale={[0.36, 0.36, 0.36]}>
        <sphereGeometry args={[1, 32, 32]} />
        <meshStandardMaterial color="#d7d0c6" emissive={primary} emissiveIntensity={0.08} />
      </mesh>
    </group>
  );
}
